import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from 'react-router-dom';

import { capitalizeFirstLetter, checkSingular, getShortName } from '@utils/Util';

const settings = {
	dots: false,
	infinite: false,
	speed: 500,
	slidesToShow: 3,
	marginRight: 16,
	slidesToScroll: 3,
	initialSlide: 0,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				infinite: true,
				dots: true
			}
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				initialSlide: 1
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				initialSlide: 1
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	]
};

const TopGallerySlider = ({ itemList, details, onCardClick, type, onComplete }) => {
	return (
		<div className="factory-slider payments-tab-slider pt-2">
			<div className="factory-slider-row d-block">
				<Slider {...settings}>
					{itemList &&
						itemList?.map((item) => (
							<div
								className={`one-fourth ${item.id === details.id ? 'active' : ''}`}
								key={item.id}
								onClick={() => onCardClick(item)}
							>
								<div className="f-info">
									{type === 'COMMERCIAL_INVOICE' ? (
										<Tooltip title={item.supplierName} placement="top" arrow>
											<Link
												onClick={(e) => e.stopPropagation()}
												className="f-title"
												to={`/suppliers/view/${item.supplierId}`}
												target="_blank"
											>
												{getShortName(item.supplierName, 35)}
											</Link>
										</Tooltip>
									) : type === 'PAYMENT' ? (
										<div className="payment-factory-info">
											<p className="regular-16 gray_dark_01">
												{getShortName(item?.commercialInvoiceNo)}
											</p>
											<Tooltip title={item?.supplierName} placement="top" arrow>
												<span className="f-name">
													{getShortName(item?.supplierName)}
												</span>
											</Tooltip>
										</div>
									) : (
										''
									)}

									{type === 'COMMERCIAL_INVOICE' ? (
										<p className="f-location regular-14">
											<img
												src={`${process.env.PUBLIC_URL}/icons/map-pin.svg`}
												alt={`${process.env.PUBLIC_URL}/icons/map-pin.svg`}
											/>{' '}
											{item?.officeLocationResponse?.city},{' '}
											{item?.officeLocationResponse?.countryResponse?.name}
										</p>
									) : (
										''
									)}
								</div>
								<div className="f-status d-flex justify-content-between align-items-center">
									{type === 'COMMERCIAL_INVOICE' ? (
										<p className="price-and-design regular-14">
											${item.productionCost}{' '}
											<span>({checkSingular('Design', item?.numberOfDesign)})</span>
										</p>
									) : type === 'PAYMENT' ? (
										<p className="price-and-design regular-14">
											<span>
												({checkSingular('Design', item?.numberOfDesign ?? 0)})
											</span>
										</p>
									) : (
										''
									)}

									{type === 'COMMERCIAL_INVOICE' ? (
										item?.completedStatus === 'PENDING' ? (
											<div className="task-status purple">
												<span className="status-btn d-flex">
													{capitalizeFirstLetter(item.completedStatus)}
												</span>
											</div>
										) : (
											<div className="task-status green">
												<span className="status-btn d-flex">
													{capitalizeFirstLetter(item.completedStatus)}
													<img
														src={`${process.env.PUBLIC_URL}/icons/completed-icon.svg`}
														alt="completed"
													/>
												</span>
											</div>
										)
									) : type === 'PAYMENT' ? (
										item?.completedStatus === 'PENDING' ? (
											<div className="approve-button">
												<button
													className="button approve size32"
													onClick={() => onComplete(item.id)}
												>
													Complete
												</button>
											</div>
										) : (
											<div className="task-status green">
												<span className="status-btn d-flex">
													{capitalizeFirstLetter(item.completedStatus)}
													<img
														src={`${process.env.PUBLIC_URL}/icons/completed-icon.svg`}
														alt="pending"
													/>
												</span>
											</div>
										)
									) : (
										''
									)}
								</div>
							</div>
						))}
				</Slider>
			</div>
		</div>
	);
};

export default TopGallerySlider;
